import React from 'react';

import CommonNode from '../../../../components/node/common-node';
import { NodeProvider } from '../../../../context/node-context';
import { getNodeName } from '../../../../utils/getNodeName';
import AppendTaskForm from './forms/append-task-form';
import { appendTaskValidationSchema } from './schema.js';

export default function FileOperationAppendNode({ data, id, type }) {
  const nodeName = getNodeName(data?.name, 'File Operation Append Task');

  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: nodeName,
        altText: 'File Operation Append Task',
        defaultLabel: 'File Operation Append Task',
      }}
    >
      <CommonNode FormComponent={AppendTaskForm} schemaResolver={appendTaskValidationSchema} />
    </NodeProvider>
  );
}
